import { render, staticRenderFns } from "./health-report.vue?vue&type=template&id=1e941880&scoped=true&"
import script from "./health-report.vue?vue&type=script&lang=js&"
export * from "./health-report.vue?vue&type=script&lang=js&"
import style0 from "./health-report.vue?vue&type=style&index=0&id=1e941880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e941880",
  null
  
)

export default component.exports